import React, { useState } from "react";

import ModalFichaTecnica from "../ModalFichaTecnica/ModalFichaTecnica";

export const MainContent = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div className="pb-1">
      <button className="btn-quiero-conocerlo outline " onClick={handleShow}>
        Ver ficha técnica
      </button>

      <ModalFichaTecnica show={show} handleClose={handleClose} />
    </div>
  );
};
